import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import HelixPiercingImage from '../../Assets/Piercing Services/helix piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function HelixPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Helix Piercing UAE | 150-175 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Helix Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Helix Piercing 150-175 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={HelixPiercingImage} alt="Helix Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Helix Piercing</h3>

          <p>
            Enhance your ear styling with our professional helix piercing services in the UAE, available at an affordable price range of 150–175 AED. Helix piercing is one of the most popular cartilage piercings, placed along the upper outer edge of the ear, offering a stylish and modern look that suits all fashion preferences. Whether you want a minimal and elegant stud or a trendy hoop for a more defined appearance, helix piercing is a versatile choice that allows you to express your personal style with ease. Our expert specialists ensure precise placement to create a balanced and aesthetically pleasing result that complements your overall look.
          </p>

          <p>
            At our piercing studio, we prioritize safety, hygiene, and comfort to deliver a premium experience for every client. Our certified professionals use sterile, single-use, high-quality equipment to perform each helix piercing with accuracy and care. We follow strict hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth procedure. Our goal is to provide a quick, efficient, and pain-minimized experience, making helix piercing suitable for both first-time clients and those looking to expand their ear piercing collection.
          </p>

          <p>
            Helix piercing is ideal for individuals who want to add a fashionable and contemporary touch to their appearance. It pairs perfectly with other ear piercings such as lobe, tragus, or conch, allowing you to create a layered and curated ear style that reflects your personality. Our specialists take the time to understand your preferences and guide you in choosing the best placement and jewelry options to achieve your desired look. Whether you prefer a single helix piercing or plan to build a stacked ear design, we ensure a customized experience tailored to your style.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient for those with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can feel intimidating for some individuals, especially first-timers, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your helix piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, helix piercings heal effectively and remain a long-lasting addition to your style.
          </p>

          <p>
            Our helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted helix piercing services in the UAE for a safe, stylish, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a trendy and elegant look effortlessly. Book your helix piercing appointment today and elevate your ear style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Helix Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HelixPiercing;